import { Component, DestroyRef, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ContactService } from '@core/services/api/contact/contact.service';
import { SvgIconComponent } from 'angular-svg-icon';
import { MessageService } from 'primeng/api';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-here-to-help',
  standalone: true,
  imports: [
    SvgIconComponent,
    InputTextModule,
    InputTextareaModule,
    ReactiveFormsModule,
    ToastModule,
  ],
  templateUrl: './here-to-help.component.html',
  styleUrl: './here-to-help.component.scss',
  providers: [MessageService],
})
export class HereToHelpComponent implements OnInit {
  contactForm!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private __contactService: ContactService,
    private messageService: MessageService,
    private destroyRef: DestroyRef,
  ) {}

  ngOnInit(): void {
    this.contactForm = this.fb.group({
      Email: ['', [Validators.required, Validators.email]],
      Number: ['', [Validators.required, Validators.pattern('^\\d+$')]],
      Name: [
        '',
        [Validators.required, Validators.pattern('^[a-zA-Z ]{1,30}$')],
      ],
      Subject: [
        '',
        [Validators.required, Validators.pattern('^[a-zA-Z ]{1,30}$')],
      ],
      Message: ['', [Validators.required, Validators.maxLength(300)]],
    });
  }

  onSubmit() {
    if (this.contactForm.invalid) {
      this.contactForm.markAllAsTouched();
      return;
    }
    this.__contactService.sendContact(this.contactForm.value).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(
      {
        error: (err) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Message Content' });
        },
        complete: () => {
          this.contactForm.reset();
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Success Send Content And Message',
          });
        }

      }
    );
  }
}
